import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { labelInsFrament } from "./queries";
import {
  InstagramLabelCreate,
  InstagramLabelCreateVariables
} from "./types/InstagramLabelCreate";
import {
  InstagramLabelDelete,
  InstagramLabelDeleteVariables
} from "./types/InstagramLabelDelete";
import {
  InstagramLabelUpdate,
  InstagramLabelUpdateVariables
} from "./types/InstagramLabelUpdate";
import {
  InstagramVisibleLabelIns,
  InstagramVisibleLabelInsVariables
} from "./types/InstagramVisibleLabelIns";
import {
  LabelCreateInstagram,
  LabelCreateInstagramVariables
} from "./types/LabelCreateInstagram";
import {
  LabelRemoveInstagram,
  LabelRemoveInstagramVariables
} from "./types/LabelRemoveInstagram";
import {
  LabelReorderInstagram,
  LabelReorderInstagramVariables
} from "./types/LabelReorderInstagram";
import {
  LabelReorderNotTopInstagram,
  LabelReorderNotTopInstagramVariables
} from "./types/LabelReorderNotTopInstagram";
import {
  LabelSortLabelins,
  LabelSortLabelinsVariables
} from "./types/LabelSortLabelins";
import {
  LabelUnsortLabelins,
  LabelUnsortLabelinsVariables
} from "./types/LabelUnsortLabelins";

export const instagramLabelDelete = gql`
  mutation InstagramLabelDelete($id: ID!) {
    instagramLabelDelete(id: $id) {
      errors {
        field
        message
      }
    }
  }
`;

export const useInstagramLabelDelete = makeMutation<
  InstagramLabelDelete,
  InstagramLabelDeleteVariables
>(instagramLabelDelete);

export const instagramLabelCreate = gql`
  mutation InstagramLabelCreate($input: InstagramLabelInput!) {
    instagramLabelCreate(input: $input) {
      label {
        id
        name
        instagramList {
          id
        }
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useInstagramLabelCreate = makeMutation<
  InstagramLabelCreate,
  InstagramLabelCreateVariables
>(instagramLabelCreate);

export const instagramLabelUpdate = gql`
  mutation InstagramLabelUpdate($id: ID!, $input: InstagramLabelInput!) {
    instagramLabelUpdate(id: $id, input: $input) {
      errors: instagramErrors {
        code
        field
      }
    }
  }
`;
export const useInstagramLabelUpdate = makeMutation<
  InstagramLabelUpdate,
  InstagramLabelUpdateVariables
>(instagramLabelUpdate);

const labelReorderInstagram = gql`
  ${labelInsFrament}
  mutation LabelReorderInstagram($id: ID!, $move: ReorderInput!) {
    labelReorderInstagram(labelId: $id, moves: [$move]) {
      label {
        id
        name
        instagramList {
          id
        }
        instagramSortList {
          ...LabelInsFrament
        }
        instagramUnsortList {
          ...LabelInsFrament
        }
      }
      errors {
        message
      }
    }
  }
`;

export const useLabelInsReorderMutation = makeMutation<
  LabelReorderInstagram,
  LabelReorderInstagramVariables
>(labelReorderInstagram);

const labelReorderNotTopInstagram = gql`
  ${labelInsFrament}
  mutation LabelReorderNotTopInstagram($id: ID!, $move: ReorderInput!) {
    labelReorderNottopInstagram(labelId: $id, moves: [$move]) {
      label {
        id
        name
        instagramList {
          id
        }
        instagramSortList {
          ...LabelInsFrament
        }
        instagramUnsortList {
          ...LabelInsFrament
        }
      }
      errors {
        message
      }
    }
  }
`;
export const useLabelNotTopInsReorderMutation = makeMutation<
  LabelReorderNotTopInstagram,
  LabelReorderNotTopInstagramVariables
>(labelReorderNotTopInstagram);

const labelRemoveInstagram = gql`
  mutation LabelRemoveInstagram($id: ID!) {
    labelRemoveInstagram(id: $id) {
      label {
        id
        instagramList {
          id
        }
      }
      errors {
        message
        field
      }
    }
  }
`;
export const useLabelRemoveInstagramMutation = makeMutation<
  LabelRemoveInstagram,
  LabelRemoveInstagramVariables
>(labelRemoveInstagram);

const labelCreateInstagram = gql`
  mutation LabelCreateInstagram($label: ID!, $instagrams: [ID]!) {
    labelCreateInstagram(labelId: $label, instagrams: $instagrams) {
      label {
        id
        name
        instagramList {
          sortOrder
          id
          instagram {
            id
          }
          label {
            id
            name
          }
          imgUrl
          userName
          insId
          published
        }
      }
      errors {
        message
        field
      }
    }
  }
`;

export const useLabelCreateInstagramMutation = makeMutation<
  LabelCreateInstagram,
  LabelCreateInstagramVariables
>(labelCreateInstagram);

const labelSortLabelins = gql`
  ${labelInsFrament}
  mutation LabelSortLabelins($ids: [ID]!) {
    labelSortLabelins(ids: $ids) {
      label {
        id
        instagramList {
          id
        }
        instagramSortList {
          ...LabelInsFrament
        }
        instagramUnsortList {
          ...LabelInsFrament
        }
      }
      instagramLabel {
        ...LabelInsFrament
      }
      errors {
        message
        field
      }
    }
  }
`;
export const useLabelSortLabelinsMutation = makeMutation<
  LabelSortLabelins,
  LabelSortLabelinsVariables
>(labelSortLabelins);

const labelUnsortLabelins = gql`
  ${labelInsFrament}
  mutation LabelUnsortLabelins($id: ID!) {
    labelUnsortLabelins(id: $id) {
      label {
        id
        instagramList {
          id
        }
      }
      instagramLabel {
        ...LabelInsFrament
      }
      errors {
        message
        field
      }
    }
  }
`;
export const useLabelUnsortLabelinsMutation = makeMutation<
  LabelUnsortLabelins,
  LabelUnsortLabelinsVariables
>(labelUnsortLabelins);

const instagramVisibleLabelIns = gql`
  ${labelInsFrament}
  mutation InstagramVisibleLabelIns($ids: [ID]!) {
    instagramVisibleLabelIns(ids: $ids) {
      label {
        id
        instagramList {
          id
        }
        instagramSortList {
          ...LabelInsFrament
        }
        instagramUnsortList {
          ...LabelInsFrament
        }
      }
      errors {
        message
        field
      }
    }
  }
`;

export const useInstagramVisibleLabelInsMutation = makeMutation<
  InstagramVisibleLabelIns,
  InstagramVisibleLabelInsVariables
>(instagramVisibleLabelIns);
